import type { Language } from '@/context/language-context'

export const translations: Record<Language, Record<string, string>> = {
  en: {
    Dashboard: 'Dashboard',
    'Monitor your restaurant performance and menu activity.':
      'Monitor your restaurant performance and menu activity.',
    Overview: 'Overview',
    'Help Center': 'Help Center',
    'Give your feedbacks': 'Give your feedbacks',
    Menu: 'Menu',
    'Manage your menu here.': 'Manage your menu here.',
    'Image to Menu': 'Image to Menu',
    'Item List': 'Item List',
    'Manage your menu items here.': 'Manage your menu items here.',
    'Add Item': 'Add Item',
    'Add Category': 'Add Category',
    Type: 'Type',
    Item: 'Item',
    'Save order': 'Save order',
    'Order saved': 'Order saved',
    'Menu order has been updated.': 'Menu order has been updated.',
    'Failed to save order': 'Failed to save order',
    'Filter menu': 'Filter menu',
    'No items in this category.': 'No items in this category.',
    'No categories or items yet. Add a category, then add items under it.':
      'No categories or items yet. Add a category, then add items under it.',
    'Your categories and items appear together in this table. Expand a category to see its items.':
      'Your categories and items appear together in this table. Expand a category to see its items.',
    'Add menu items with this button after you have categories.':
      'Add menu items with this button after you have categories.',
    'Create Category': 'Create Category',
    'Select Category': 'Select Category',
    'No categories found. Please create a category first.':
      'No categories found. Please create a category first.',
    Settings: 'Settings',
    'Manage your account settings.': 'Manage your account settings.',
    Shop: 'Shop',
    Profile: 'Profile',
    Security: 'Security',
    'Create Shop': 'Create Shop',
    'Add a new shop to your organization.':
      'Add a new shop to your organization.',
    'Coming Soon \uD83D\uDC40': 'Coming Soon \uD83D\uDC40',
    'Coming Soon': 'Coming Soon',
    'This page has not been created yet. Stay tuned though!':
      'This page has not been created yet. Stay tuned though!',
    'Log out': 'Log out',
    Search: 'Search',
    'Toggle theme': 'Toggle theme',
    Light: 'Light',
    Dark: 'Dark',
    System: 'System',
    Login: 'Login',
    'Enter your email and password below to log into your account':
      'Enter your email and password below to log into your account',
    'Password reset successful! You can now sign in with your new password.':
      'Password reset successful! You can now sign in with your new password.',
    'By clicking login, you agree to our':
      'By clicking login, you agree to our',
    and: 'and',
    'Terms of Service': 'Terms of Service',
    'Privacy Policy': 'Privacy Policy',
    'Create an account': 'Create an account',
    'Enter your email and password to create an account.':
      'Enter your email and password to create an account.',
    'Already have an account?': 'Already have an account?',
    'By creating an account, you agree to our':
      'By creating an account, you agree to our',
    'Sign In': 'Sign In',
    'Two-factor Authentication': 'Two-factor Authentication',
    'Please enter the authentication code. We have sent the authentication code to your email.':
      'Please enter the authentication code. We have sent the authentication code to your email.',
    'Resend a new code.': 'Resend a new code.',
    "Haven't received it?": "Haven't received it?",
    'Oops! Page Not Found!': 'Oops! Page Not Found!',
    "It seems like the page you're looking for does not exist or might have been removed.":
      "It seems like the page you're looking for does not exist or might have been removed.",
    'Go Back': 'Go Back',
    'Go to Settings': 'Go to Settings',
    'Back to Home': 'Back to Home',
    'Back to Login': 'Back to Login',
    'QR Settings': 'QR Settings',
    'QR Destination': 'QR Destination',
    'Shop Home': 'Shop Home',
    'Choose where customers will land when scanning the QR code':
      'Choose where customers will land when scanning the QR code',
    'QR Color': 'QR Color',
    'QR Codes': 'QR Codes',
    'Branded QR codes for your menu, sections, reviews and table tents.':
      'Branded QR codes for your menu, sections, reviews and table tents.',
    'Quick styles': 'Quick styles',
    'Tap to apply': 'Tap to apply',
    'Where this QR sends people when scanned':
      'Where this QR sends people when scanned',
    'Live preview': 'Live preview',
    Live: 'Live',
    'Scan to view our menu': 'Scan to view our menu',
    'Powered by Menu Points': 'Powered by Menu Points',
    Style: 'Style',
    Frame: 'Frame',
    'Dot pattern': 'Dot pattern',
    'Eye shape': 'Eye shape',
    Foreground: 'Foreground',
    'Eye accent': 'Eye accent',
    'Gradient foreground': 'Gradient foreground',
    'Cycle: tomato → pumpkin': 'Cycle: tomato → pumpkin',
    'Center logo': 'Center logo',
    'Adds error-correction padding automatically':
      'Adds error-correction padding automatically',
    'Recommended ≤ 25% of QR': 'Recommended ≤ 25% of QR',
    Replace: 'Replace',
    'Corner radius': 'Corner radius',
    'Frame style': 'Frame style',
    None: 'None',
    'Pill label': 'Pill label',
    Banner: 'Banner',
    'Table tent': 'Table tent',
    'Label text': 'Label text',
    'Shows above/around the QR': 'Shows above/around the QR',
    'Bottom CTA': 'Bottom CTA',
    'mile-end.menupts.io': 'mile-end.menupts.io',
    'Show arrow ↓': 'Show arrow ↓',
    Format: 'Format',
    'Download QR': 'Download QR',
    'Error generating QR code': 'Error generating QR code',
    'Unknown error': 'Unknown error',
    Destination: 'Destination',
    Background: 'Background',
    'Upload Logo (optional)': 'Upload Logo (optional)',
    Preview: 'Preview',
    'Open Menu Editor': 'Open Menu Editor',
    'Generating…': 'Generating…',
    Download: 'Download',
    'Copy Link': 'Copy Link',
    'Copied!': 'Copied!',
    'Menu Points Admin': 'Menu Points Admin',
    Tasks: 'Tasks',
    "Here's a list of your tasks for this month!":
      "Here's a list of your tasks for this month!",
    'App Integrations': 'Available Apps',
    "Here's a list of your apps for the integration!":
      'Browse and connect apps to enhance your service.',
    'Filter apps...': 'Filter apps...',
    'All Apps': 'All Apps',
    Connected: 'Connected',
    'Not Connected': 'Not Connected',
    Ascending: 'Ascending',
    Descending: 'Descending',
    Connect: 'Connect',
    Available: 'Available',
    'Loading apps...': 'Loading apps...',
    'No apps found': 'No apps found',
    'Successfully connected to {{plugin}}':
      'Successfully connected to {{plugin}}',
    'Successfully disconnected from {{plugin}}':
      'Successfully disconnected from {{plugin}}',
    'Failed to connect app': 'Failed to connect app',
    'Failed to disconnect app': 'Failed to disconnect app',
    Inbox: 'Inbox',
    'Search chat...': 'Search chat...',
    'Type your messages...': 'Type your messages...',
    'Your messages': 'Your messages',
    'Send a message to start a chat.': 'Send a message to start a chat.',
    'Send message': 'Send message',
    'Invite User': 'Invite User',
    'Add User': 'Add User',
    'User List': 'User List',
    'Manage your users and their roles here.':
      'Manage your users and their roles here.',
    'This is your dashboard.': 'This is your dashboard.',
    Size: 'Size',
    Back: 'Back',
    Queue: 'Queue',
    Reservation: 'Reservation',
    'AI Waiter': 'AI Waiter',
    "Easily manage your shop's waiting line":
      "Easily manage your shop's waiting line",
    'Handle reservations without hassle': 'Handle reservations without hassle',
    'Let our digital waiter assist your guests':
      'Let our digital waiter assist your guests',
    'Total views your pages received today.':
      'Total views your pages received today.',
    'Unique visitors who accessed your site today.':
      'Unique visitors who accessed your site today.',
    'Average time users spent on your site today.':
      'Average time users spent on your site today.',
    'Sessions with only one page view.': 'Sessions with only one page view.',
    'Traffic trends for the past week.': 'Traffic trends for the past week.',
    'Number of users currently active on your site.':
      'Number of users currently active on your site.',
    'Menu items with the most clicks today.':
      'Menu items with the most clicks today.',
    'You can see your daily stats here.': 'You can see your daily stats here.',
    'You can see weekly stats here to compare weekdays.':
      'You can see weekly stats here to compare weekdays.',
    'Check which items get the most views and compare them.':
      'Check which items get the most views and compare them.',
    'Just now': 'Just now',
    '1 minute ago': '1 minute ago',
    'seconds ago': 'seconds ago',
    'minutes ago': 'minutes ago',
    'hours ago': 'hours ago',
    'Refresh Data': 'Refresh Data',
    'Refreshing...': 'Refreshing...',
    'Create your account': 'Create your account',
    'Enter your email and create a password to get started':
      'Enter your email and create a password to get started',
    'Create a secure password': 'Create a secure password',
    'Confirm your password': 'Confirm your password',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    Email: 'Email',
    Password: 'Password',
    'Confirm Password': 'Confirm Password',
    'Phone Number': 'Phone Number',
    'Organization details': 'Organization details',
    'Tell us about your organization': 'Tell us about your organization',
    'Organization name': 'Organization name',
    'Organization logo (optional)': 'Organization logo (optional)',
    'Choose File': 'Choose File',
    'PNG, JPG up to 5MB': 'PNG, JPG up to 5MB',
    'Shop details': 'Shop details',
    'Set up your first shop': 'Set up your first shop',
    'Shop name': 'Shop name',
    'Shop address': 'Shop address',
    'Enter shop address': 'Enter shop address',
    'Shop description': 'Shop description',
    'Enter a brief description of your shop':
      'Enter a brief description of your shop',
    'All set!': 'All set!',
    'Your account has been created successfully':
      'Your account has been created successfully',
    "You're all set!": "You're all set!",
    'Your shop is ready to start serving customers':
      'Your shop is ready to start serving customers',
    'Account created': 'Account created',
    'Organization setup': 'Organization setup',
    'Shop configured': 'Shop configured',
    'Welcome to Menu Points': 'Welcome to Menu Points',
    "Let's set up your shop in just a few steps":
      "Let's set up your shop in just a few steps",
    Continue: 'Continue',
    Finish: 'Finish',
    'Submitting...': 'Submitting...',
    'Loading...': 'Loading...',
    'First name is required': 'First name is required',
    'Last name is required': 'Last name is required',
    'Email is required': 'Email is required',
    'Password is required': 'Password is required',
    'Passwords do not match': 'Passwords do not match',
    'Phone number is required': 'Phone number is required',
    'Organization name is required': 'Organization name is required',
    'Shop name is required': 'Shop name is required',
    'Shop address is required': 'Shop address is required',
    'Shop description is required': 'Shop description is required',
    'Something went wrong. Please try again.':
      'Something went wrong. Please try again.',
    'Error uploading logo. Please try again.':
      'Error uploading logo. Please try again.',
    'Bulk create menu items from uploaded images':
      'Bulk create menu items from uploaded images',
    'Menu Image Upload': 'Menu Image Upload',
    'Menu preview': 'Menu preview',
    'Scanning menu...': 'Scanning menu...',
    'Drop your menu image here': 'Drop your menu image here',
    'or click to browse files': 'or click to browse files',
    'Confirm & Bulk Create': 'Confirm & Bulk Create',
    'Reprocess Image': 'Reprocess Image',
    'Detected Menu Items': 'Detected Menu Items',
    'Detected {count} menu items.': 'Detected {count} menu items.',
    'Saving...': 'Saving...',
    'Save All Items': 'Save All Items',
    Category: 'Category',
    'Select category': 'Select category',
    Uncategorized: 'Uncategorized',
    'Please select a category': 'Please select a category',
    Description: 'Description',
    'Enter description': 'Enter description',
    Price: 'Price',
    'Order Priority': 'Order Priority',
    Created: 'Created',
    Updated: 'Updated',
    'Delete Menu Item': 'Delete Menu Item',
    'Are you sure you want to delete this menu item?':
      'Are you sure you want to delete this menu item?',
    'This action cannot be undone.': 'This action cannot be undone.',
    Delete: 'Delete',
    'Item deleted': 'Item deleted',
    'The menu item has been removed from the list.':
      'The menu item has been removed from the list.',
    'Missing categories': 'Missing categories',
    'Please select a category for all items. Items without category':
      'Please select a category for all items. Items without category',
    Error: 'Error',
    'Session expired!': 'Session expired!',
    Success: 'Success',
    'Please ensure a shop is selected.': 'Please ensure a shop is selected.',
    'Successfully saved': 'Successfully saved',
    'item(s)': 'item(s)',
    'Partial success': 'Partial success',
    saved: 'saved',
    failed: 'failed',
    'Failed to save items.': 'Failed to save items.',
    'Invalid file type': 'Invalid file type',
    'Please select an image file.': 'Please select an image file.',
    'No active shop selected': 'No active shop selected',
    'Failed to process image.': 'Failed to process image.',
    'Please select an image and ensure a shop is selected.':
      'Please select an image and ensure a shop is selected.',
    'Unnamed Item': 'Unnamed Item',
    'Save Changes': 'Save Changes',
    'Switch between Menu, Items and Categories tabs here.':
      'Switch between Menu, Items and Categories tabs here.',
    'Start by selecting the Categories tab.':
      'Start by selecting the Categories tab.',
    'Create a category by clicking this button.':
      'Create a category by clicking this button.',
    Skip: 'Skip',
    Next: 'Next',
    Close: 'Close',
    Last: 'Last',
    Open: 'Open',
    Step: 'Step',
    of: ' of ',
    'Step {current} of {total}': 'Step {current} of {total}',
    'Go to menu': 'Go to menu',
    'Quick Links': 'Quick Links',
    Apps: 'Apps',
    Analytics: 'Analytics',
    General: 'General',
    Management: 'Management',
    Stats: 'Stats',
    Integrations: 'Integrations',
    Other: 'Other',
    'Shop Settings': 'Shop Settings',
    "Customize your shop's functionality.":
      "Customize your shop's functionality.",
    'Shop Name': 'Shop Name',
    'Shop name required': 'Shop name required',
    'Please enter the shop name for at least one language.':
      'Please enter the shop name for at least one language.',
    'Description generated': 'Description generated',
    'Shop descriptions populated for all languages.':
      'Shop descriptions populated for all languages.',
    'Failed to generate description': 'Failed to generate description',
    'Please try again later.': 'Please try again later.',
    'Shop settings updated successfully': 'Shop settings updated successfully',
    'Your changes have been saved.': 'Your changes have been saved.',
    'Failed to update shop settings': 'Failed to update shop settings',
    'Failed to load shop settings': 'Failed to load shop settings',
    'Please refresh the page and try again.':
      'Please refresh the page and try again.',
    'Loading shop settings...': 'Loading shop settings...',
    Currency: 'Currency',
    'Select currency': 'Select currency',
    'Search currency...': 'Search currency...',
    'No currency found.': 'No currency found.',
    'This is the currency that will be used in your shop.':
      'This is the currency that will be used in your shop.',
    Languages: 'Languages',
    'Select languages': 'Select languages',
    'Search language...': 'Search language...',
    'No language found.': 'No language found.',
    'Select the languages available for your menu.':
      'Select the languages available for your menu.',
    'Shop Description': 'Shop Description',
    'Menu URL slug': 'Menu URL slug',
    'your-restaurant-name': 'your-restaurant-name',
    'The path customers use to open your menu. Changing it breaks old links until you share the new URL.':
      'The path customers use to open your menu. Changing it breaks old links until you share the new URL.',
    'Checking menu URL availability...': 'Checking menu URL availability...',
    'This menu URL is available': 'This menu URL is available',
    'This menu URL is already in use': 'This menu URL is already in use',
    'Enter a valid menu URL (at least 2 characters, letters and numbers)':
      'Enter a valid menu URL (at least 2 characters, letters and numbers)',
    'Enter a valid menu URL (at least 2 characters, letters, numbers, and hyphens)':
      'Enter a valid menu URL (at least 2 characters, letters, numbers, and hyphens)',
    'Could not verify menu URL. Check your connection and try again.':
      'Could not verify menu URL. Check your connection and try again.',
    'Menu URL preview': 'Menu URL preview',
    'Public menu links for each language in your shop':
      'Public menu links for each language in your shop',
    'Enter a slug to preview URLs': 'Enter a slug to preview URLs',
    'Open menu in new tab': 'Open menu in new tab',
    'Resolve menu URL issues before saving.':
      'Resolve menu URL issues before saving.',
    Logo: 'Logo',
    'Weekly Schedule': 'Weekly Schedule',
    'Weekly schedule': 'Weekly schedule',
    'Configure opening & break hours for each day.':
      'Configure opening & break hours for each day.',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    'Saving changes...': 'Saving changes...',
    'Update shop': 'Update shop',
    'Logo preview': 'Logo preview',
    'Change Logo': 'Change Logo',
    'Upload your logo file. Max 2MB, JPG, PNG or SVG formats supported.':
      'Upload your logo file. Max 2MB, JPG, PNG or SVG formats supported.',
    'Uploading file...': 'Uploading file...',
    'An error occurred while uploading the file':
      'An error occurred while uploading the file',
    'Hero image': 'Hero image',
    'Image preview': 'Image preview',
    'Change image': 'Change image',
    'Remove image': 'Remove image',
    'No image': 'No image',
    'Upload an image. Max 5MB, JPG or PNG formats supported.':
      'Upload an image. Max 5MB, JPG or PNG formats supported.',
    Work: 'Work',
    Break: 'Break',
    Closed: 'Closed',
    'Remove break': 'Remove break',
    'Add break': 'Add break',
    'Add New Social Media Link': 'Add New Social Media Link',
    URL: 'URL',
    Platform: 'Platform',
    'Select platform': 'Select platform',
    Add: 'Add',
    'Remove social link': 'Remove social link',
    Account: 'Account',
    'Update your account settings. Set your preferred language and timezone.':
      'Update your account settings. Set your preferred language and timezone.',
    Name: 'Name',
    'Your name': 'Your name',
    'This is the name that will be displayed on your profile and in emails.':
      'This is the name that will be displayed on your profile and in emails.',
    'Date of birth': 'Date of birth',
    'Pick a date': 'Pick a date',
    'Your date of birth is used to calculate your age.':
      'Your date of birth is used to calculate your age.',
    Language: 'Language',
    'Select language': 'Select language',
    'This is the language that will be used in the dashboard.':
      'This is the language that will be used in the dashboard.',
    Username: 'Username',
    'This is your public display name. It can be your real name or a pseudonym. You can only change this once every 30 days.':
      'This is your public display name. It can be your real name or a pseudonym. You can only change this once every 30 days.',
    'Select a verified email to display': 'Select a verified email to display',
    'You can manage verified email addresses in your':
      'You can manage verified email addresses in your',
    'email settings': 'email settings',
    Bio: 'Bio',
    'Tell us a little bit about yourself':
      'Tell us a little bit about yourself',
    'You can': 'You can',
    'other users and organizations to link to them.':
      'other users and organizations to link to them.',
    'Update account': 'Update account',
    Display: 'Display',
    "Turn items on or off to control what's displayed in the app.":
      "Turn items on or off to control what's displayed in the app.",
    'You submitted the following values:':
      'You submitted the following values:',
    Sidebar: 'Sidebar',
    'Select the items you want to display in the sidebar.':
      'Select the items you want to display in the sidebar.',
    'Update display': 'Update display',
    Notifications: 'Notifications',
    'Configure how you receive notifications.':
      'Configure how you receive notifications.',
    'Notify me about...': 'Notify me about...',
    'All new messages': 'All new messages',
    'Direct messages and mentions': 'Direct messages and mentions',
    Nothing: 'Nothing',
    'Email Notifications': 'Email Notifications',
    'Communication emails': 'Communication emails',
    'Receive emails about your account activity.':
      'Receive emails about your account activity.',
    'Marketing emails': 'Marketing emails',
    'Receive emails about new products, features, and more.':
      'Receive emails about new products, features, and more.',
    'Social emails': 'Social emails',
    'Receive emails for friend requests, follows, and more.':
      'Receive emails for friend requests, follows, and more.',
    'Security emails': 'Security emails',
    'Receive emails about your account activity and security.':
      'Receive emails about your account activity and security.',
    'Use different settings for my mobile devices':
      'Use different settings for my mobile devices',
    'You can manage your mobile notifications in the':
      'You can manage your mobile notifications in the',
    'mobile settings': 'mobile settings',
    'page.': 'page.',
    'Update notifications': 'Update notifications',
    'This is how others will see you on the site.':
      'This is how others will see you on the site.',
    Surname: 'Surname',
    'Your Surname': 'Your Surname',
    'Account updated': 'Account updated',
    'Loading profile settings...': 'Loading profile settings...',
    'This is where you can change your password.':
      'This is where you can change your password.',
    'Password updated': 'Password updated',
    'Your password has been successfully changed.':
      'Your password has been successfully changed.',
    Unauthorized: 'Unauthorized',
    'Your current password is incorrect.':
      'Your current password is incorrect.',
    'Failed to change password. Please try again.':
      'Failed to change password. Please try again.',
    'Current Password': 'Current Password',
    'Enter your current password to verify your identity.':
      'Enter your current password to verify your identity.',
    'New Password': 'New Password',
    'Password must be at least 8 characters with uppercase, lowercase, and numbers.':
      'Password must be at least 8 characters with uppercase, lowercase, and numbers.',
    'Confirm New Password': 'Confirm New Password',
    'Update Password': 'Update Password',
    Recents: 'Recents',
    Home: 'Home',
    Applications: 'Applications',
    Desktop: 'Desktop',
    Downloads: 'Downloads',
    Documents: 'Documents',
    "Don't have an account?": "Don't have an account?",
    'Sign up': 'Sign up',
    'Please complete the reCAPTCHA verification':
      'Please complete the reCAPTCHA verification',
    'Password looks good!': 'Password looks good!',
    'Passwords match': 'Passwords match',
    'No logo': 'No logo',
    optional: 'optional',
    complete: 'complete',
    'Please enter a valid email address': 'Please enter a valid email address',
    'Password must be at least 8 characters':
      'Password must be at least 8 characters',
    'Please confirm your password': 'Please confirm your password',
    'Tell customers what makes your shop special':
      'Tell customers what makes your shop special',
    'File size must be less than 5MB': 'File size must be less than 5MB',
    'Please upload an image file': 'Please upload an image file',
    'reCAPTCHA will verify automatically when you submit':
      'reCAPTCHA will verify automatically when you submit',
    'reCAPTCHA verification completed': 'reCAPTCHA verification completed',
    'Failed to verify reCAPTCHA. Please try again.':
      'Failed to verify reCAPTCHA. Please try again.',
    'Please complete the reCAPTCHA verification below':
      'Please complete the reCAPTCHA verification below',
    'This site is protected by reCAPTCHA and the Google':
      'This site is protected by reCAPTCHA and the Google',
    apply: 'apply',
    'reCAPTCHA verified': 'reCAPTCHA verified',
    'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.':
      'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.',
    'Setup Complete!': 'Setup Complete!',
    'Your organization and shop have been successfully created.':
      'Your organization and shop have been successfully created.',
    "Let's set up your account and shop": "Let's set up your account and shop",
    Done: 'Done',
    'You are ready to go!': 'You are ready to go!',
    'Brief description of your shop...': 'Brief description of your shop...',
    'Min. 8 characters': 'Min. 8 characters',
    'Full name is required': 'Full name is required',
    'Please enter both first and last name':
      'Please enter both first and last name',
    'reCAPTCHA verification failed. Please try again.':
      'reCAPTCHA verification failed. Please try again.',
    'Full Name': 'Full Name',
    'This site is protected by reCAPTCHA.':
      'This site is protected by reCAPTCHA.',
    Restaurant: 'Restaurant',
    'Set up your restaurant': 'Set up your restaurant',
    'Restaurant Name': 'Restaurant Name',
    'This will be displayed to your customers.':
      'This will be displayed to your customers.',
    'All Set!': 'All Set!',
    'Your restaurant has been successfully created.':
      'Your restaurant has been successfully created.',
    "Let's get your restaurant up and running":
      "Let's get your restaurant up and running",
    'Please wait': 'Please wait',
    'Go to Dashboard': 'Go to Dashboard',
    'Translation error': 'Translation error',
    'Something went wrong while translating.':
      'Something went wrong while translating.',
    'Description error': 'Description error',
    'Something went wrong while generating.':
      'Something went wrong while generating.',
    'Item Name': 'Item Name',
    'Item Description': 'Item Description',
    'Category Name': 'Category Name',
    'Quick add common categories': 'Quick add common categories',
    'Select status': 'Select status',
    Active: 'Active',
    Passive: 'Passive',
    'Item Images': 'Item Images',
    'Hide Default Images': 'Hide Default Images',
    'Show Default Images': 'Show Default Images',
    Items: 'Items',
    Categories: 'Categories',
    'Select all': 'Select all',
    'Select row': 'Select row',
    QR: 'QR',
    Organization: 'Organization',
    Billing: 'Billing',
    'Current plan': 'Current plan',
    Free: 'Free',
    Plus: 'Plus',
    Pro: 'Pro',
    Enterprise: 'Enterprise',
    'Manage subscriptions, monthly totals, and the Lemon Squeezy customer portal.':
      'Manage subscriptions, monthly totals, and the Lemon Squeezy customer portal.',
    'Total monthly': 'Total monthly',
    'Manage billing': 'Manage billing',
    'Confirming your subscription…': 'Confirming your subscription…',
    'Activation pending — refresh in a moment.':
      'Activation pending — refresh in a moment.',
    "You're on the Free plan. Upgrade for more capacity and features.":
      "You're on the Free plan. Upgrade for more capacity and features.",
    'Upgrade to Plus': 'Upgrade to Plus',
    'Upgrade to Pro': 'Upgrade to Pro',
    'No billing profile yet — subscribe from Upgrade first.':
      'No billing profile yet — subscribe from Upgrade first.',
    'Verifying with the server (up to 30 seconds).':
      'Verifying with the server (up to 30 seconds).',
    'No subscription rows yet for this organization.':
      'No subscription rows yet for this organization.',
    Refresh: 'Refresh',
    Entitlement: 'Entitlement',
    'Billing email': 'Billing email',
    'Something went wrong': 'Something went wrong',
    'Mobile phone': 'Mobile phone',
    'Your mobile phone number is used for notifications.':
      'Your mobile phone number is used for notifications.',
    'Filter items': 'Filter items',
    Status: 'Status',
    'Rows per page': 'Rows per page',
    Page: 'Page',
    View: 'View',
    'Toggle columns': 'Toggle columns',
    Actions: 'Actions',
    'Forgot Password': 'Forgot Password',
    'Forgot password?': 'Forgot password?',
    'Enter your registered email and we will send you a link to reset your password.':
      'Enter your registered email and we will send you a link to reset your password.',
    'Please enter your email': 'Please enter your email',
    'Invalid email address': 'Invalid email address',
    'Email Sent': 'Email Sent',
    'If an account with this email exists, you will receive a password reset link.':
      'If an account with this email exists, you will receive a password reset link.',
    'Failed to send reset email. Please try again.':
      'Failed to send reset email. Please try again.',
    'Active Now': 'Active Now',
    'Page Views': 'Page Views',
    Visitors: 'Visitors',
    'Time on Site': 'Time on Site',
    Bounces: 'Bounces',
    'since yesterday': 'since yesterday',
    // Menu Editor
    'Menu Editor': 'Menu Editor',
    'Design your menu':
      'Design your menu',
    Saved: 'Saved',
    'Unsaved changes': 'Unsaved changes',
    'Up to date': 'Up to date',
    Revert: 'Revert',
    Publish: 'Publish',
    Published: 'Published',
    Draft: 'Draft',
    Templates: 'Templates',
    'Discard draft': 'Discard draft',
    'Discard draft and restore last published version':
      'Discard draft and restore last published version',
    'No changes to publish': 'No changes to publish',
    'Menu actions': 'Menu actions',
    'Draft conflict detected': 'Draft conflict detected',
    'This design changed in another tab or device. Reload latest draft to continue safely.':
      'This design changed in another tab or device. Reload latest draft to continue safely.',
    'Reload latest': 'Reload latest',
    'Retry attempts': 'Retry attempts',
    'Template applied': 'Template applied',
    'Draft updated — publish when you are ready.':
      'Draft updated — publish when you are ready.',
    'Publish menu design?': 'Publish menu design?',
    'This will make your current design visible to all customers scanning the QR code. The previous published version will be replaced.':
      'This will make your current design visible to all customers scanning the QR code. The previous published version will be replaced.',
    'Discard draft and restore published version?':
      'Discard draft and restore published version?',
    'All unsaved draft changes will be lost. Your menu will be restored to the last published snapshot. This action cannot be undone.':
      'All unsaved draft changes will be lost. Your menu will be restored to the last published snapshot. This action cannot be undone.',
    Conflict: 'Conflict',
    'Sync error — Retry': 'Sync error — Retry',
    'All changes published': 'All changes published',
    'Menu design changed elsewhere': 'Menu design changed elsewhere',
    'Reloading the latest draft to avoid overwriting changes.':
      'Reloading the latest draft to avoid overwriting changes.',
    'Auto-save failed': 'Auto-save failed',
    'Check your connection and try again.':
      'Check your connection and try again.',
    'Publish your menu design? This will make it visible to customers.':
      'Publish your menu design? This will make it visible to customers.',
    'Menu published': 'Menu published',
    'Publish failed': 'Publish failed',
    'Revert to the last published snapshot?':
      'Revert to the last published snapshot?',
    'Reverted to published version': 'Reverted to published version',
    'Revert failed': 'Revert failed',
    'Loading menu design…': 'Loading menu design…',
    'Failed to load menu design.': 'Failed to load menu design.',
    'Check your connection or try again': 'Check your connection or try again',
    Retry: 'Retry',
    // Menu Editor – Puck config
    'Subscription required': 'Subscription required',
    Mobile: 'Mobile',
    Tablet: 'Tablet',
    Social: 'Social',
    Vertical: 'Vertical',
    Cards: 'Cards',
    'Compact rows': 'Compact rows',
    'Show categories': 'Show categories',
    'Show search bar': 'Show search bar',
    'Search placeholder': 'Search placeholder',
    'No categories yet': 'No categories yet',
    'No matches': 'No matches',
    'Show prices': 'Show prices',
    'Show descriptions': 'Show descriptions',
    'Show Item Tags': 'Show Item Tags',
    'Select a menu section to preview your live categories and items.':
      'Select a menu section to preview your live categories and items.',
    Phone: 'Phone',
    Address: 'Address',
    'Show map preview': 'Show map preview',
    Contact: 'Contact',
    'Phone, email and address info': 'Phone, email and address info',
    'Add contact fields to preview this section.':
      'Add contact fields to preview this section.',
    'Map preview': 'Map preview',
    'Map rendering will be implemented in the rendering phase.':
      'Map rendering will be implemented in the rendering phase.',
    Left: 'Left',
    Center: 'Center',
    Right: 'Right',
    'Add social links to preview.': 'Add social links to preview.',
    'Please try again.': 'Please try again.',
    // Phase 8 — billing / upgrade / cancellation
    'Plan changed': 'Plan changed',
    'Cancellation initiated': 'Cancellation initiated',
    'Your plan will remain active until the end of the current billing period. It will not automatically renew.':
      'Your plan will remain active until the end of the current billing period. It will not automatically renew.',
    'Your plugin will remain active until the end of the current billing period. It will not automatically renew.':
      'Your plugin will remain active until the end of the current billing period. It will not automatically renew.',
    'You will have access until {{date}}': 'You will have access until {{date}}',
    'Activation pending — refresh page': 'Activation pending — refresh page',
    'Activating your subscription...': 'Activating your subscription...',
    'Cancel Plan': 'Cancel Plan',
    'Cancel plugin': 'Cancel plugin',
    'Confirm Cancellation': 'Confirm Cancellation',
    'Enterprise Contact': 'Enterprise Contact',
    'or contact us at': 'or contact us at',
    'Most Popular': 'Most Popular',
    'Upgrade Now': 'Upgrade Now',
    'Free Forever': 'Free Forever',
    'per month': 'per month',
    'Contact us for pricing': 'Contact us for pricing',
    '/mo': '/mo',
    Disconnect: 'Disconnect',
    'Upgrade Your Account': 'Upgrade Your Account',
    'Choose the perfect plan for your business needs and unlock more features':
      'Choose the perfect plan for your business needs and unlock more features',
    'Current Plan': 'Current Plan',
    'Plan activated': 'Plan activated',
    'Select a shop first': 'Select a shop first',
    'Cancel your paid plan to return to Free':
      'Cancel your paid plan to return to Free',
    'Contact Sales': 'Contact Sales',
    'Need help choosing the right plan?':
      'Need help choosing the right plan?',
    'Contact Support': 'Contact Support',
    Custom: 'Custom',
    'Perfect for getting started': 'Perfect for getting started',
    'For small businesses': 'For small businesses',
    'For growing businesses': 'For growing businesses',
    'For large organizations': 'For large organizations',
    '1 Shop': '1 Shop',
    'Free Menu Management': 'Free Menu Management',
    'QR Code Generation': 'QR Code Generation',
    'Email Support': 'Email Support',
    'Free Analytics': 'Free Analytics',
    'Up to 2 Shops': 'Up to 2 Shops',
    'Unlimited menu items': 'Unlimited menu items',
    'Custom QR Codes': 'Custom QR Codes',
    'Priority Support': 'Priority Support',
    'Advanced Analytics': 'Advanced Analytics',
    'Paid marketplace apps': 'Paid marketplace apps',
    'Unlimited Shops': 'Unlimited Shops',
    'Custom Branding': 'Custom Branding',
    'All Pro Features': 'All Pro Features',
    'Dedicated Account Manager': 'Dedicated Account Manager',
    '24/7 Phone Support': '24/7 Phone Support',
    'Custom Integrations': 'Custom Integrations',
    'White Label Solution': 'White Label Solution',
    'Advanced Security': 'Advanced Security',
    'SLA Guarantee': 'SLA Guarantee',
  },
  tr: {
    Dashboard: 'Gösterge Paneli',
    'Monitor your restaurant performance and menu activity.':
      'Restoran performansınızı ve menü etkinliğinizi takip edin.',
    Overview: 'Genel Bakış',
    'Help Center': 'Yardım Merkezi',
    'Give your feedbacks': 'Görüşlerinizi iletin',
    Menu: 'Menü',
    'Manage your menu here.': 'Menünüzü burada yönetin.',
    'Image to Menu': 'Resimden Menü',
    'Item List': 'Ürün Listesi',
    'Manage your menu items here.': 'Menü ürünlerinizi burada yönetin.',
    'Add Item': 'Ürün Ekle',
    'Add Category': 'Kategori Ekle',
    Type: 'Tür',
    Item: 'Ürün',
    'Save order': 'Sırayı kaydet',
    'Order saved': 'Sıra kaydedildi',
    'Menu order has been updated.': 'Menü sırası güncellendi.',
    'Failed to save order': 'Sıra kaydedilemedi',
    'Filter menu': 'Menüyü filtrele',
    'No items in this category.': 'Bu kategoride ürün yok.',
    'No categories or items yet. Add a category, then add items under it.':
      'Henüz kategori veya ürün yok. Önce bir kategori ekleyin, ardından altına ürün ekleyin.',
    'Your categories and items appear together in this table. Expand a category to see its items.':
      'Kategorileriniz ve ürünleriniz bu tabloda birlikte görünür. Ürünleri görmek için bir kategoriyi genişletin.',
    'Add menu items with this button after you have categories.':
      'Kategorilerinizi oluşturduktan sonra bu düğmeyle ürün ekleyin.',
    'Create Category': 'Kategori Oluştur',
    'Select Category': 'Kategori Seç',
    'No categories found. Please create a category first.':
      'Kategori bulunamadı. Lütfen önce bir kategori oluşturun.',
    Settings: 'Ayarlar',
    'Manage your account settings.': 'Hesap ayarlarınızı yönetin.',
    Shop: 'Mağaza',
    Profile: 'Profil',
    Security: 'Güvenlik',
    'Create Shop': 'Mağaza Oluştur',
    'Add a new shop to your organization.':
      'Organizasyonunuza yeni bir mağaza ekleyin.',
    'Coming Soon \uD83D\uDC40': 'Çok Yakında \uD83D\uDC40',
    'Coming Soon': 'Çok Yakında',
    'This page has not been created yet. Stay tuned though!':
      'Bu sayfa henüz oluşturulmadı. Takipte kalın!',
    'Log out': 'Çıkış Yap',
    Search: 'Ara',
    'Toggle theme': 'Temayı değiştir',
    Light: 'Açık',
    Dark: 'Koyu',
    System: 'Sistem',
    Login: 'Giriş Yap',
    'Enter your email and password below to log into your account':
      'Hesabınıza giriş yapmak için e-posta ve şifrenizi girin',
    'Password reset successful! You can now sign in with your new password.':
      'Şifre sıfırlama başarılı! Artık yeni şifrenizle giriş yapabilirsiniz.',
    'By clicking login, you agree to our':
      'Giriş yaparak şunları kabul etmiş olursunuz',
    and: 've',
    'Terms of Service': 'Hizmet Şartları',
    'Privacy Policy': 'Gizlilik Politikası',
    'Create an account': 'Hesap Oluştur',
    'Enter your email and password to create an account.':
      'Hesap oluşturmak için e-posta ve şifrenizi girin.',
    'Already have an account?': 'Zaten hesabınız var mı?',
    'By creating an account, you agree to our':
      'Hesap oluşturarak şunları kabul etmiş olursunuz',
    'Sign In': 'Giriş Yap',
    'Two-factor Authentication': 'İki Faktörlü Doğrulama',
    'Please enter the authentication code. We have sent the authentication code to your email.':
      'Lütfen doğrulama kodunu girin. Kod e-posta adresinize gönderildi.',
    'Resend a new code.': 'Yeni kodu tekrar gönder.',
    "Haven't received it?": 'Kod gelmedi mi?',
    'Oops! Page Not Found!': '404! Sayfa Bulunamadı',
    "It seems like the page you're looking for does not exist or might have been removed.":
      'Aradığınız sayfa mevcut değil veya kaldırılmış olabilir.',
    'Go Back': 'Geri Dön',
    'Go to Settings': 'Ayarlara Git',
    'Back to Home': 'Ana Sayfaya Dön',
    'Back to Login': 'Giriş Yap',
    'QR Settings': 'QR Ayarları',
    'QR Destination': 'QR Hedefi',
    'Shop Home': 'Mağaza Ana Sayfa',
    'Choose where customers will land when scanning the QR code':
      'Müşteriler QR kodunu taradığında hangi sayfaya yönlendirileceğini seçin',
    'QR Color': 'QR Rengi',
    'QR Codes': 'QR Kodları',
    'Branded QR codes for your menu, sections, reviews and table tents.':
      'Menünüz, bölümleriniz, yorumlarınız ve masa tenteleri için markalı QR kodları.',
    'Quick styles': 'Hızlı stiller',
    'Tap to apply': 'Uygulamak için dokunun',
    'Where this QR sends people when scanned':
      'Bu QR tarandığında insanları nereye gönderir',
    'Live preview': 'Canlı önizleme',
    Live: 'Canlı',
    'Scan to view our menu': 'Menüyü görmek için tarayın',
    'Powered by Menu Points': 'Menu Points tarafından desteklenmektedir',
    Style: 'Stil',
    Frame: 'Çerçeve',
    'Dot pattern': 'Nokta deseni',
    'Eye shape': 'Göz şekli',
    Foreground: 'Ön plan',
    'Eye accent': 'Göz vurgusu',
    'Gradient foreground': 'Gradyan ön plan',
    'Cycle: tomato → pumpkin': 'Döngü: domates → balkabağı',
    'Center logo': 'Merkez logo',
    'Adds error-correction padding automatically':
      'Hata düzeltme dolgusunu otomatik ekler',
    'Recommended ≤ 25% of QR': 'QR alanının ≤ %25 önerilir',
    Replace: 'Değiştir',
    'Corner radius': 'Köşe yarıçapı',
    'Frame style': 'Çerçeve stili',
    None: 'Yok',
    'Pill label': 'Hap etiket',
    Banner: 'Banner',
    'Table tent': 'Masa tentesi',
    'Label text': 'Etiket metni',
    'Shows above/around the QR': 'QR kodunun üstünde/etrafında gösterilir',
    'Bottom CTA': 'Alt CTA',
    'mile-end.menupts.io': 'mile-end.menupts.io',
    'Show arrow ↓': 'Ok göster ↓',
    Format: 'Format',
    'Download QR': 'QR İndir',
    'Error generating QR code': 'QR kodu oluşturulurken hata',
    'Unknown error': 'Bilinmeyen hata',
    Background: 'Arkaplan',
    'Upload Logo (optional)': 'Logo Yükle (isteğe bağlı)',
    Preview: 'Önizleme',
    'Open Menu Editor': 'Menü Editörünü Aç',
    'Generating…': 'Oluşturuluyor…',
    Download: 'İndir',
    'Copy Link': 'Bağlantıyı Kopyala',
    'Copied!': 'Kopyalandı!',
    'Menu Points Admin': 'Menu Points Admin',
    Tasks: 'Görevler',
    "Here's a list of your tasks for this month!":
      'Bu ayki görevlerinizin listesi!',
    'App Integrations': 'Mevcut Uygulamalar',
    "Here's a list of your apps for the integration!":
      'İşinizi geliştirmek için uygulamaları inceleyip bağlayın.',
    'Filter apps...': 'Uygulamaları filtrele...',
    'All Apps': 'Tüm Uygulamalar',
    Connected: 'Bağlı',
    'Not Connected': 'Bağlı Değil',
    Ascending: 'Artan',
    Descending: 'Azalan',
    Connect: 'Bağlan',
    Available: 'Mevcut',
    'Loading apps...': 'Uygulamalar yükleniyor...',
    'No apps found': 'Uygulama bulunamadı',
    'Successfully connected to {{plugin}}':
      '{{plugin}} bağlantısı başarıyla kuruldu',
    'Successfully disconnected from {{plugin}}':
      '{{plugin}} bağlantısı başarıyla kaldırıldı',
    'Failed to connect app': 'Uygulama bağlanılamadı',
    'Failed to disconnect app': 'Uygulama bağlantısı kaldırılamadı',
    Inbox: 'Gelen Kutusu',
    'Search chat...': 'Sohbet ara...',
    'Type your messages...': 'Mesajınızı yazın...',
    'Your messages': 'Mesajlarınız',
    'Send a message to start a chat.': 'Sohbet başlatmak için mesaj gönderin.',
    'Send message': 'Mesaj gönder',
    'Invite User': 'Kullanıcı Davet Et',
    'Add User': 'Kullanıcı Ekle',
    'User List': 'Kullanıcı Listesi',
    'Manage your users and their roles here.':
      'Kullanıcılarınızı ve rollerini burada yönetin.',
    'This is your dashboard.': 'Bu sizin kontrol paneliniz.',
    Size: 'Boyut',
    Back: 'Geri',
    Queue: 'Sıra',
    Reservation: 'Rezervasyon',
    'AI Waiter': 'Yapay Zeka Garson',
    "Easily manage your shop's waiting line":
      'Mağazanızın bekleme sırasını kolayca yönetin',
    'Handle reservations without hassle': 'Rezervasyonları zahmetsizce yönetin',
    'Let our digital waiter assist your guests':
      'Dijital garsonumuz misafirlerinize yardımcı olsun',
    'Total views your pages received today.':
      'Sayfalarınızın bugün aldığı toplam görüntülenme.',
    'Unique visitors who accessed your site today.':
      'Bugün sitenizi ziyaret eden benzersiz kullanıcılar.',
    'Average time users spent on your site today.':
      'Kullanıcıların bugün sitenizde geçirdiği ortalama süre.',
    'Sessions with only one page view.':
      'Yalnızca tek sayfa görüntülenen oturumlar.',
    'Traffic trends for the past week.': 'Geçen haftanın trafik eğilimleri.',
    'Number of users currently active on your site.':
      'Şu anda sitenizde aktif olan kullanıcı sayısı.',
    'Menu items with the most clicks today.':
      'Bugün en çok tıklanan menü ürünleri.',
    'You can see your daily stats here.':
      'Günlük istatistiklerinizi burada görebilirsiniz.',
    'You can see weekly stats here to compare weekdays.':
      'Haftalık istatistiklerinizi burada görüp günleri karşılaştırabilirsiniz.',
    'Check which items get the most views and compare them.':
      'Hangi ürünlerin en çok görüntülendiğini görüp karşılaştırabilirsiniz.',
    'Just now': 'Az önce',
    '1 minute ago': '1 dakika önce',
    'seconds ago': 'saniye önce',
    'minutes ago': 'dakika önce',
    'hours ago': 'saat önce',
    'Refresh Data': 'Verileri Yenile',
    'Refreshing...': 'Yenileniyor...',
    'Create your account': 'Hesabınızı oluşturun',
    'Enter your email and create a password to get started':
      'Başlamak için e-postanızı girin ve bir şifre oluşturun',
    'Create a secure password': 'Güçlü bir şifre oluşturun',
    'Confirm your password': 'Şifrenizi doğrulayın',
    'First Name': 'Ad',
    'Last Name': 'Soyad',
    Email: 'E-posta',
    Password: 'Şifre',
    'Confirm Password': 'Şifreyi Onayla',
    'Phone Number': 'Telefon Numarası',
    'Organization details': 'Organizasyon detayları',
    'Tell us about your organization':
      'Organizasyonunuz hakkında bize bilgi verin',
    'Organization name': 'Organizasyon adı',
    'Organization logo (optional)': 'Organizasyon logosu (isteğe bağlı)',
    'Choose File': 'Dosya Seç',
    'PNG, JPG up to 5MB': 'PNG, JPG en fazla 5MB',
    'Shop details': 'Mağaza detayları',
    'Set up your first shop': 'İlk mağazanızı kurun',
    'Shop name': 'Mağaza adı',
    'Shop address': 'Mağaza adresi',
    'Enter shop address': 'Mağaza adresini girin',
    'Shop description': 'Mağaza açıklaması',
    'Enter a brief description of your shop':
      'Mağazanız için kısa bir açıklama girin',
    'All set!': 'Her şey hazır!',
    'Your account has been created successfully':
      'Hesabınız başarıyla oluşturuldu',
    "You're all set!": 'Hazırsınız!',
    'Your shop is ready to start serving customers':
      'Mağazanız hizmet vermeye hazır',
    'Account created': 'Hesap oluşturuldu',
    'Organization setup': 'Organizasyon ayarlandı',
    'Shop configured': 'Mağaza yapılandırıldı',
    'Welcome to Menu Points': "Menu Points'e Hoş Geldiniz",
    "Let's set up your shop in just a few steps":
      'Mağazanızı birkaç adımda kurun',
    Continue: 'Devam',
    Finish: 'Bitir',
    'Submitting...': 'Gönderiliyor...',
    'Loading...': 'Yükleniyor...',
    'First name is required': 'Ad gerekli',
    'Last name is required': 'Soyad gerekli',
    'Email is required': 'E-posta gerekli',
    'Password is required': 'Şifre gerekli',
    'Passwords do not match': 'Şifreler uyuşmuyor',
    'Phone number is required': 'Telefon numarası gerekli',
    'Organization name is required': 'Organizasyon adı gerekli',
    'Shop name is required': 'Mağaza adı gerekli',
    'Shop address is required': 'Mağaza adresi gerekli',
    'Shop description is required': 'Mağaza açıklaması gerekli',
    'Something went wrong. Please try again.':
      'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
    'Error uploading logo. Please try again.':
      'Logo yüklenirken hata oluştu. Lütfen tekrar deneyin.',
    'Bulk create menu items from uploaded images':
      'Yüklenen görsellerden toplu menü öğesi oluştur',
    'Menu Image Upload': 'Menü Görseli Yükleme',
    'Menu preview': 'Menü önizlemesi',
    'Scanning menu...': 'Menü taranıyor...',
    'Drop your menu image here': 'Menü görselinizi buraya bırakın',
    'or click to browse files': 'veya dosya seçmek için tıklayın',
    'Confirm & Bulk Create': 'Onayla ve Toplu Oluştur',
    'Reprocess Image': 'Görseli Yeniden İşle',
    'Detected Menu Items': 'Tespit Edilen Menü Öğeleri',
    'Detected {count} menu items.': '{count} menü öğesi tespit edildi.',
    'Saving...': 'Kaydediliyor...',
    'Save All Items': 'Tüm Öğeleri Kaydet',
    Category: 'Kategori',
    'Select category': 'Kategori seç',
    Uncategorized: 'Kategorisiz',
    'Please select a category': 'Lütfen bir kategori seçin',
    Description: 'Açıklama',
    'Enter description': 'Açıklama girin',
    Price: 'Fiyat',
    'Order Priority': 'Sıralama Önceliği',
    Created: 'Oluşturuldu',
    Updated: 'Güncellendi',
    'Delete Menu Item': 'Menü Öğesini Sil',
    'Are you sure you want to delete this menu item?':
      'Bu menü öğesini silmek istediğinizden emin misiniz?',
    'This action cannot be undone.': 'Bu işlem geri alınamaz.',
    Delete: 'Sil',
    'Item deleted': 'Öğe silindi',
    'The menu item has been removed from the list.':
      'Menü öğesi listeden kaldırıldı.',
    'Missing categories': 'Eksik kategoriler',
    'Please select a category for all items. Items without category':
      'Lütfen tüm öğeler için kategori seçin. Kategorisi olmayan öğeler',
    Error: 'Hata',
    'Session expired!': 'Oturum süresi doldu!',
    Success: 'Başarılı',
    'Please ensure a shop is selected.':
      'Lütfen bir mağaza seçildiğinden emin olun.',
    'Successfully saved': 'Başarıyla kaydedildi',
    'item(s)': 'öğe',
    'Partial success': 'Kısmi başarı',
    saved: 'kaydedildi',
    failed: 'başarısız',
    'Failed to save items.': 'Öğeler kaydedilemedi.',
    'Invalid file type': 'Geçersiz dosya türü',
    'Please select an image file.': 'Lütfen bir görsel dosyası seçin.',
    'No active shop selected': 'Aktif mağaza seçilmedi',
    'Failed to process image.': 'Görsel işlenemedi.',
    'Please select an image and ensure a shop is selected.':
      'Lütfen bir görsel seçin ve bir mağaza seçildiğinden emin olun.',
    'Unnamed Item': 'İsimsiz Öğe',
    'Save Changes': 'Değişiklikleri Kaydet',
    'Switch between Menu, Items and Categories tabs here.':
      'Menü, Ürünler ve Kategoriler sekmeleri arasında geçiş yapın.',
    'Start by selecting the Categories tab.':
      'Kategoriler sekmesini seçerek başlayın.',
    'Create a category by clicking this button.':
      'Bu düğmeye tıklayarak bir kategori oluşturun.',
    Skip: 'Atla',
    Next: 'İleri',
    Close: 'Kapat',
    Last: 'Son',
    Open: 'Aç',
    Step: 'Adım',
    of: ' / ',
    'Step {current} of {total}': '{current} / {total}',
    'Go to menu': 'Menüye Git',
    'Quick Links': 'Hızlı Bağlantılar',
    Apps: 'Uygulamalar',
    Analytics: 'Analiz',
    General: 'Genel',
    Management: 'Yönetim',
    Stats: 'İstatistikler',
    Integrations: 'Entegrasyonlar',
    Other: 'Diğer',
    'Shop Settings': 'Mağaza Ayarları',
    "Customize your shop's functionality.":
      'Mağaza işlevlerinizi özelleştirin.',
    'Shop Name': 'Mağaza Adı',
    'Shop name required': 'Mağaza adı gerekli',
    'Please enter the shop name for at least one language.':
      'Lütfen en az bir dil için mağaza adını girin.',
    'Description generated': 'Açıklama oluşturuldu',
    'Shop descriptions populated for all languages.':
      'Mağaza açıklamaları tüm diller için dolduruldu.',
    'Failed to generate description': 'Açıklama oluşturulamadı',
    'Please try again later.': 'Lütfen daha sonra tekrar deneyin.',
    'Shop settings updated successfully':
      'Mağaza ayarları başarıyla güncellendi',
    'Your changes have been saved.': 'Değişiklikleriniz kaydedildi.',
    'Failed to update shop settings': 'Mağaza ayarları güncellenemedi',
    'Failed to load shop settings': 'Mağaza ayarları yüklenemedi',
    'Please refresh the page and try again.':
      'Lütfen sayfayı yenileyip tekrar deneyin.',
    'Loading shop settings...': 'Mağaza ayarları yükleniyor...',
    Currency: 'Para Birimi',
    'Select currency': 'Para birimi seç',
    'Search currency...': 'Para birimi ara...',
    'No currency found.': 'Para birimi bulunamadı.',
    'This is the currency that will be used in your shop.':
      'Mağazanızda kullanılacak para birimi budur.',
    Languages: 'Diller',
    'Select languages': 'Dilleri seç',
    'Search language...': 'Dil ara...',
    'No language found.': 'Dil bulunamadı.',
    'Select the languages available for your menu.':
      'Menünüz için mevcut dilleri seçin.',
    'Shop Description': 'Mağaza Açıklaması',
    'Menu URL slug': 'Menü URL adresi',
    'your-restaurant-name': 'restoran-adiniz',
    'The path customers use to open your menu. Changing it breaks old links until you share the new URL.':
      'Müşterilerin menünüzü açmak için kullandığı adres yolu. Değiştirmek, yeni URL paylaşana kadar eski bağlantıları bozar.',
    'Checking menu URL availability...': 'Menü URL uygunluğu kontrol ediliyor...',
    'This menu URL is available': 'Bu menü URL adresi kullanılabilir',
    'This menu URL is already in use': 'Bu menü URL adresi zaten kullanılıyor',
    'Enter a valid menu URL (at least 2 characters, letters and numbers)':
      'Geçerli bir menü URL adresi girin (en az 2 karakter, harf ve rakam)',
    'Enter a valid menu URL (at least 2 characters, letters, numbers, and hyphens)':
      'Geçerli bir menü URL adresi girin (en az 2 karakter; harf, rakam ve tire)',
    'Could not verify menu URL. Check your connection and try again.':
      'Menü URL adresi doğrulanamadı. Bağlantınızı kontrol edip tekrar deneyin.',
    'Menu URL preview': 'Menü URL önizlemesi',
    'Public menu links for each language in your shop':
      'Mağazanızdaki her dil için herkese açık menü bağlantıları',
    'Enter a slug to preview URLs': 'URL önizlemesi için bir adres girin',
    'Open menu in new tab': 'Menüyü yeni sekmede aç',
    'Resolve menu URL issues before saving.':
      'Kaydetmeden önce menü URL sorunlarını giderin.',
    Logo: 'Logo',
    'Weekly Schedule': 'Haftalık Program',
    'Weekly schedule': 'Haftalık program',
    'Configure opening & break hours for each day.':
      'Her gün için açılış ve mola saatlerini yapılandırın.',
    Monday: 'Pazartesi',
    Tuesday: 'Salı',
    Wednesday: 'Çarşamba',
    Thursday: 'Perşembe',
    Friday: 'Cuma',
    Saturday: 'Cumartesi',
    Sunday: 'Pazar',
    'Saving changes...': 'Değişiklikler kaydediliyor...',
    'Update shop': 'Mağazayı güncelle',
    'Logo preview': 'Logo önizleme',
    'Change Logo': 'Logoyu Değiştir',
    'Upload your logo file. Max 2MB, JPG, PNG or SVG formats supported.':
      'Logo dosyanızı yükleyin. Maksimum 2MB, JPG, PNG veya SVG formatları desteklenir.',
    'Uploading file...': 'Dosya yükleniyor...',
    'An error occurred while uploading the file':
      'Dosya yüklenirken bir hata oluştu',
    'Hero image': 'Hero görseli',
    'Image preview': 'Görsel önizleme',
    'Change image': 'Görseli değiştir',
    'Remove image': 'Görseli kaldır',
    'No image': 'Görsel yok',
    'Upload an image. Max 5MB, JPG or PNG formats supported.':
      'Bir görsel yükleyin. En fazla 5MB, JPG veya PNG desteklenir.',
    Work: 'Çalışma',
    Break: 'Mola',
    Closed: 'Kapalı',
    'Remove break': 'Molayı kaldır',
    'Add break': 'Mola ekle',
    'Add New Social Media Link': 'Yeni Sosyal Medya Bağlantısı Ekle',
    URL: 'URL',
    Platform: 'Platform',
    'Select platform': 'Platform seç',
    Add: 'Ekle',
    'Remove social link': 'Sosyal bağlantıyı kaldır',
    Account: 'Hesap',
    'Update your account settings. Set your preferred language and timezone.':
      'Hesap ayarlarınızı güncelleyin. Tercih ettiğiniz dili ve saat dilimini ayarlayın.',
    Name: 'Ad',
    'Your name': 'Adınız',
    'This is the name that will be displayed on your profile and in emails.':
      'Bu ad profilinizde ve e-postalarda görüntülenecektir.',
    'Date of birth': 'Doğum tarihi',
    'Pick a date': 'Bir tarih seçin',
    'Your date of birth is used to calculate your age.':
      'Doğum tarihiniz yaşınızı hesaplamak için kullanılır.',
    Language: 'Dil',
    'Select language': 'Dil seçin',
    'This is the language that will be used in the dashboard.':
      'Bu dil panelde kullanılacaktır.',
    Username: 'Kullanıcı Adı',
    'This is your public display name. It can be your real name or a pseudonym. You can only change this once every 30 days.':
      'Bu sizin herkese açık görünen adınızdır. Gerçek adınız veya takma adınız olabilir. Bunu her 30 günde bir değiştirebilirsiniz.',
    'Select a verified email to display':
      'Görüntülemek için doğrulanmış bir e-posta seçin',
    'You can manage verified email addresses in your':
      'Doğrulanmış e-posta adreslerini şuradan yönetebilirsiniz:',
    'email settings': 'e-posta ayarları',
    Bio: 'Biyografi',
    'Tell us a little bit about yourself': 'Bize biraz kendinizden bahsedin',
    'You can': 'Şunları yapabilirsiniz',
    'other users and organizations to link to them.':
      'diğer kullanıcıları ve organizasyonları etiketleyerek onlara bağlantı verebilirsiniz.',
    'Update account': 'Hesabı güncelle',
    Display: 'Görünüm',
    "Turn items on or off to control what's displayed in the app.":
      'Uygulamada neyin görüntüleneceğini kontrol etmek için öğeleri açıp kapatın.',
    'You submitted the following values:': 'Aşağıdaki değerleri gönderdiniz:',
    Sidebar: 'Kenar Çubuğu',
    'Select the items you want to display in the sidebar.':
      'Kenar çubuğunda görüntülemek istediğiniz öğeleri seçin.',
    'Update display': 'Görünümü güncelle',
    Notifications: 'Bildirimler',
    'Configure how you receive notifications.':
      'Bildirimleri nasıl alacağınızı yapılandırın.',
    'Notify me about...': 'Bana şunları bildir...',
    'All new messages': 'Tüm yeni mesajlar',
    'Direct messages and mentions': 'Doğrudan mesajlar ve bahsetmeler',
    Nothing: 'Hiçbir şey',
    'Email Notifications': 'E-posta Bildirimleri',
    'Communication emails': 'İletişim e-postaları',
    'Receive emails about your account activity.':
      'Hesap etkinliğiniz hakkında e-postalar alın.',
    'Marketing emails': 'Pazarlama e-postaları',
    'Receive emails about new products, features, and more.':
      'Yeni ürünler, özellikler ve daha fazlası hakkında e-postalar alın.',
    'Social emails': 'Sosyal e-postalar',
    'Receive emails for friend requests, follows, and more.':
      'Arkadaşlık istekleri, takipler ve daha fazlası için e-postalar alın.',
    'Security emails': 'Güvenlik e-postaları',
    'Receive emails about your account activity and security.':
      'Hesap etkinliğiniz ve güvenliğiniz hakkında e-postalar alın.',
    'Use different settings for my mobile devices':
      'Mobil cihazlarım için farklı ayarlar kullan',
    'You can manage your mobile notifications in the':
      'Mobil bildirimlerinizi şuradan yönetebilirsiniz:',
    'mobile settings': 'mobil ayarlar',
    'page.': 'sayfası.',
    'Update notifications': 'Bildirimleri güncelle',
    'This is how others will see you on the site.':
      'Başkaları sizi sitede bu şekilde görecek.',
    Surname: 'Soyad',
    'Your Surname': 'Soyadınız',
    'Account updated': 'Hesap güncellendi',
    'Loading profile settings...': 'Profil ayarları yükleniyor...',
    'This is where you can change your password.':
      'Buradan şifrenizi değiştirebilirsiniz.',
    'Password updated': 'Şifre güncellendi',
    'Your password has been successfully changed.':
      'Şifreniz başarıyla değiştirildi.',
    Unauthorized: 'Yetkisiz',
    'Your current password is incorrect.': 'Mevcut şifreniz yanlış.',
    'Failed to change password. Please try again.':
      'Şifre değiştirilemedi. Lütfen tekrar deneyin.',
    'Current Password': 'Mevcut Şifre',
    'Enter your current password to verify your identity.':
      'Kimliğinizi doğrulamak için mevcut şifrenizi girin.',
    'New Password': 'Yeni Şifre',
    'Password must be at least 8 characters with uppercase, lowercase, and numbers.':
      'Şifre en az 8 karakter uzunluğunda olmalı, büyük harf, küçük harf ve rakam içermelidir.',
    'Confirm New Password': 'Yeni Şifreyi Onayla',
    'Update Password': 'Şifreyi Güncelle',
    Recents: 'Son Kullanılanlar',
    Home: 'Ana Sayfa',
    Applications: 'Uygulamalar',
    Desktop: 'Masaüstü',
    Downloads: 'İndirilenler',
    Documents: 'Belgeler',
    "Don't have an account?": 'Hesabınız yok mu?',
    'Sign up': 'Hesap Oluştur',
    'Please complete the reCAPTCHA verification':
      'Lütfen reCAPTCHA doğrulamasını tamamlayın',
    'Password looks good!': 'Şifre iyi görünüyor!',
    'Passwords match': 'Şifreler eşleşiyor',
    'No logo': 'Logo yok',
    optional: 'isteğe bağlı',
    complete: 'tamamlandı',
    'Please enter a valid email address':
      'Lütfen geçerli bir e-posta adresi girin',
    'Password must be at least 8 characters':
      'Şifre en az 8 karakter olmalıdır',
    'Please confirm your password': 'Lütfen şifrenizi onaylayın',
    'Tell customers what makes your shop special':
      'Müşterilere mağazanızı özel yapan şeyi anlatın',
    'File size must be less than 5MB': "Dosya boyutu 5MB'dan küçük olmalıdır",
    'Please upload an image file': 'Lütfen bir resim dosyası yükleyin',
    'reCAPTCHA will verify automatically when you submit':
      'reCAPTCHA gönderdiğinizde otomatik olarak doğrulanacak',
    'reCAPTCHA verification completed': 'reCAPTCHA doğrulaması tamamlandı',
    'Failed to verify reCAPTCHA. Please try again.':
      'reCAPTCHA doğrulanamadı. Lütfen tekrar deneyin.',
    'Please complete the reCAPTCHA verification below':
      'Lütfen aşağıdaki reCAPTCHA doğrulamasını tamamlayın',
    'This site is protected by reCAPTCHA and the Google':
      'Bu site reCAPTCHA ve Google tarafından korunmaktadır',
    apply: 'uygulanır',
    'reCAPTCHA verified': 'reCAPTCHA doğrulandı',
    'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.':
      "Bu site reCAPTCHA ve Google'ın Gizlilik Politikası ve Hizmet Şartları uygulanmaktadır.",
    'Setup Complete!': 'Kurulum Tamamlandı!',
    'Your organization and shop have been successfully created.':
      'Organizasyon ve mağaza başarıyla oluşturuldu.',
    "Let's set up your account and shop": 'Hesabınızı ve mağazanızı kurun',
    Done: 'Bitti',
    'You are ready to go!': 'Hazırsınız!',
    'Brief description of your shop...':
      'Mağazanız hakkında kısa bir açıklama girin...',
    'Full name is required': 'Ad gerekli',
    'Please enter both first and last name':
      'Lütfen hem adınızı hem de soyadınızı girin',
    'Min. 8 characters': 'Min. 8 karakter',
    'reCAPTCHA verification failed. Please try again.':
      'reCAPTCHA doğrulaması başarısız oldu. Lütfen tekrar deneyin.',
    'Full Name': 'Tam Ad',
    'This site is protected by reCAPTCHA.':
      'Bu site reCAPTCHA ile korunmaktadır.',
    Restaurant: 'Restoran',
    'Set up your restaurant': 'Restoranınızı kurun',
    'Restaurant Name': 'Restoran Adı',
    'This will be displayed to your customers.':
      'Bu müşterilerinize gösterilecektir.',
    'All Set!': 'Her Şey Hazır!',
    'Your restaurant has been successfully created.':
      'Restoranınız başarıyla oluşturuldu.',
    "Let's get your restaurant up and running":
      'Restoranınızı çalışır hale getirelim',
    'Please wait': 'Lütfen bekleyin',
    'Go to Dashboard': 'Panele Git',
    'Translation error': 'Çeviri hatası',
    'Something went wrong while translating.':
      'Çeviri sırasında bir hata oluştu.',
    'Description error': 'Açıklama hatası',
    'Something went wrong while generating.':
      'Oluşturma sırasında bir hata oluştu.',
    'Item Name': 'Ürün Adı',
    'Item Description': 'Ürün Açıklaması',
    'Category Name': 'Kategori Adı',
    'Quick add common categories': 'Hızlı kategori ekle',
    'Select status': 'Durum seç',
    Active: 'Aktif',
    Passive: 'Pasif',
    'Item Images': 'Ürün Görselleri',
    'Hide Default Images': 'Varsayılan Görselleri Gizle',
    'Show Default Images': 'Varsayılan Görselleri Göster',
    Items: 'Ürünler',
    Categories: 'Kategoriler',
    'Select all': 'Tümünü seç',
    'Select row': 'Satırı seç',
    QR: 'QR',
    Organization: 'Organizasyon',
    Billing: 'Faturalama',
    'Current plan': 'Mevcut plan',
    Free: 'Ücretsiz',
    Plus: 'Plus',
    Pro: 'Pro',
    Enterprise: 'Kurumsal',
    'Manage subscriptions, monthly totals, and the Lemon Squeezy customer portal.':
      'Abonelikleri, aylık toplamları ve Lemon Squeezy müşteri portalını yönetin.',
    'Total monthly': 'Aylık toplam',
    'Manage billing': 'Faturalamayı yönet',
    'Confirming your subscription…': 'Aboneliğiniz doğrulanıyor…',
    'Activation pending — refresh in a moment.':
      'Etkinleştirme bekliyor — biraz sonra yenileyin.',
    "You're on the Free plan. Upgrade for more capacity and features.":
      'Ücretsiz plandasınız. Daha fazla kapasite ve özellik için yükseltin.',
    'Upgrade to Plus': "Plus'a yükselt",
    'Upgrade to Pro': "Pro'ya yükselt",
    'No billing profile yet — subscribe from Upgrade first.':
      'Henüz faturalama profili yok — önce Yükselt üzerinden abone olun.',
    'Verifying with the server (up to 30 seconds).':
      'Sunucu ile doğrulanıyor (en fazla 30 saniye).',
    'No subscription rows yet for this organization.':
      'Bu organizasyon için henüz abonelik kaydı yok.',
    Refresh: 'Yenile',
    Entitlement: 'Yetki',
    'Billing email': 'Fatura e-postası',
    'Something went wrong': 'Bir şeyler yanlış gitti',
    'Mobile phone': 'Cep telefonu',
    'Your mobile phone number is used for notifications.':
      'Cep telefonu numaranız bildirimler için kullanılır.',
    'No results.': 'Sonuç bulunamadı.',
    'Filter items': 'Ürünleri filtrele',
    Status: 'Durum',
    'Rows per page': 'Sayfa başına satır',
    Page: 'Sayfa',
    View: 'Görünüm',
    'Toggle columns': 'Sütunları göster/gizle',
    Actions: 'İşlemler',
    Content: 'İçerik',
    'Forgot Password': 'Şifremi Unuttum',
    'Forgot password?': 'Şifrenizi mi unuttunuz?',
    'Enter your registered email and we will send you a link to reset your password.':
      'Kayıtlı e-posta adresinizi girin, size şifre sıfırlama bağlantısı göndereceğiz.',
    'Please enter your email': 'Lütfen e-posta adresinizi girin',
    'Invalid email address': 'Geçersiz e-posta adresi',
    'Email Sent': 'E-posta Gönderildi',
    'If an account with this email exists, you will receive a password reset link.':
      'Bu e-posta adresine kayıtlı bir hesap varsa, şifre sıfırlama bağlantısı alacaksınız.',
    'Failed to send reset email. Please try again.':
      'Sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin.',
    Design: 'Tasarım',
    'Upload Logo': 'Logo Yükle',
    'Add your brand logo to the center of the QR code. We recommend using a square image with a transparent background.':
      "Markanızın logo'sunu QR kodunun ortasına ekleyin. Transparan bir arka plan ile kare bir görsel kullanmanızı öneririz.",
    'Copied to Clipboard': 'Panoya Kopyalandı',
    'You can print this QR code on your tables, flyers, or window display to give customers instant access to your menu.':
      'Bu QR kodu masaüstlerinize, flyerlerinize veya pencere görüntülerinize yazdırarak müşterilerinize menüye anında erişim sağlayabilirsiniz.',
    'Did you know?': 'Bilinmeyen bir şey var mı?',
    'Select the language for the QR code destination.':
      'QR kodunun hedef dilini seçin.',
    Destination: 'Hedef',
    'Menu Page': 'Menü Sayfası',
    'Customers will land on your shop profile page.':
      'Müşteriler mağaza profil sayfasına yönlendirilecektir.',
    'Customers will land directly on the menu.':
      'Müşteriler menüye doğrudan yönlendirilecektir.',
    'QR Code Generator': 'QR Kod Oluşturucu',
    'Customize and download your unique shop QR code.':
      'Mağaza QR kodunuzu özelleştirin ve indirin.',
    'Active Now': 'Şu Anda Aktif',
    'Page Views': 'Sayfa Görüntülenmeleri',
    Visitors: 'Ziyaretçiler',
    'Time on Site': 'Sitede Geçen Süre',
    Bounces: 'Bounces',
    'since yesterday': 'dün itibariyle',
    // Menü Editörü
    'Menu Editor': 'Menü Editörü',
    'Design your menu': 'Menünüzü tasarlayın',
    Saved: 'Kaydedildi',
    'Unsaved changes': 'Kaydedilmemiş değişiklikler',
    'Up to date': 'Güncel',
    Revert: 'Geri Al',
    Publish: 'Yayınla',
    Published: 'Yayınlandı',
    Draft: 'Taslak',
    Templates: 'Şablonlar',
    'Discard draft': 'Taslağı sil',
    'Discard draft and restore last published version':
      'Taslağı sil ve son yayınlanan sürümü geri yükle',
    'No changes to publish': 'Yayınlanacak değişiklik yok',
    'Menu actions': 'Menü işlemleri',
    'Draft conflict detected': 'Taslak çakışması algılandı',
    'This design changed in another tab or device. Reload latest draft to continue safely.':
      'Bu tasarım başka bir sekmede veya cihazda değişti. Güvenle devam etmek için son taslağı yeniden yükleyin.',
    'Reload latest': 'Son sürümü yükle',
    'Retry attempts': 'Tekrar deneme sayısı',
    'Template applied': 'Şablon uygulandı',
    'Draft updated — publish when you are ready.':
      'Taslak güncellendi — hazır olduğunuzda yayınlayın.',
    'Publish menu design?': 'Menü tasarımı yayınlansın mı?',
    'This will make your current design visible to all customers scanning the QR code. The previous published version will be replaced.':
      'Bu işlem mevcut tasarımınızı QR kodunu tarayan tüm müşterilere görünür yapar. Önceki yayınlanan sürüm değiştirilecektir.',
    'Discard draft and restore published version?':
      'Taslak silinip yayınlanan sürüm geri yüklensin mi?',
    'All unsaved draft changes will be lost. Your menu will be restored to the last published snapshot. This action cannot be undone.':
      'Kaydedilmemiş tüm taslak değişiklikleri kaybolacak. Menünüz son yayınlanan sürüme geri yüklenecek. Bu işlem geri alınamaz.',
    Conflict: 'Çakışma',
    'Sync error — Retry': 'Senkronizasyon hatası — Tekrar dene',
    'All changes published': 'Tüm değişiklikler yayınlandı',
    'Menu design changed elsewhere':
      'Menü tasarımı başka bir yerden değiştirildi',
    'Reloading the latest draft to avoid overwriting changes.':
      'Değişikliklerin üzerine yazmamak için son taslak yeniden yükleniyor.',
    'Auto-save failed': 'Otomatik kaydetme başarısız',
    'Check your connection and try again.':
      'Bağlantınızı kontrol edin ve tekrar deneyin.',
    'Publish your menu design? This will make it visible to customers.':
      'Menü tasarımınızı yayınlamak istiyor musunuz? Bu, müşterilere görünür hale gelecektir.',
    'Menu published': 'Menü yayınlandı',
    'Publish failed': 'Yayınlama başarısız',
    'Revert to the last published snapshot?':
      'Son yayınlanan sürüme geri dönülsün mü?',
    'Reverted to published version': 'Yayınlanan sürüme geri dönüldü',
    'Revert failed': 'Geri alma başarısız',
    'Loading menu design…': 'Menü tasarımı yükleniyor…',
    'Failed to load menu design.': 'Menü tasarımı yüklenemedi.',
    'Check your connection or try again':
      'Bağlantınızı kontrol edin veya tekrar deneyin',
    Retry: 'Tekrar Dene',
    // Menü Editörü – Puck yapılandırma
    'Subscription required': 'Abonelik gerekli',
    Mobile: 'Mobil',
    Tablet: 'Tablet',
    Social: 'Sosyal',
    Vertical: 'Dikey',
    Cards: 'Kartlar',
    'Compact rows': 'Kompakt satırlar',
    'Show categories': 'Kategorileri göster',
    'Show search bar': 'Arama çubuğunu göster',
    'Search placeholder': 'Arama yer tutucusu',
    'No categories yet': 'Henüz kategori yok',
    'No matches': 'Eşleşme yok',
    'Show prices': 'Fiyatları göster',
    'Show descriptions': 'Açıklamaları göster',
    'Show Item Tags': 'Ürün etiketlerini göster',
    'Select a menu section to preview your live categories and items.':
      'Canlı kategorilerinizi ve ürünlerinizi önizlemek için bir menü bölümü seçin.',
    Phone: 'Telefon',
    Address: 'Adres',
    'Show map preview': 'Harita önizlemesini göster',
    Contact: 'İletişim',
    'Phone, email and address info': 'Telefon, e-posta ve adres bilgileri',
    'Add contact fields to preview this section.':
      'Bu bölümü önizlemek için iletişim alanlarını ekleyin.',
    'Map preview': 'Harita önizlemesi',
    'Map rendering will be implemented in the rendering phase.':
      'Harita görüntüleme, render aşamasında uygulanacaktır.',
    Left: 'Sol',
    Center: 'Orta',
    Right: 'Sağ',
    'Add social links to preview.':
      'Önizlemek için sosyal bağlantılar ekleyin.',
    'Please try again.': 'Lütfen tekrar deneyin.',
    'Plan changed': 'Plan değiştirildi',
    'Cancellation initiated': 'İptal başlatıldı',
    'Your plan will remain active until the end of the current billing period. It will not automatically renew.':
      'Planınız mevcut fatura dönemine kadar aktif kalacaktır. Otomatik olarak yenilenmeyecektir.',
    'Your plugin will remain active until the end of the current billing period. It will not automatically renew.':
      'Uygulamanız mevcut fatura dönemine kadar aktif kalacaktır. Otomatik olarak yenilenmeyecektir.',
    'You will have access until {{date}}': '{{date}} tarihine kadar erişim sahibi olacaksınız',
    'Activation pending — refresh page': 'Etkinleştirme bekliyor — sayfayı yenileyin',
    'Activating your subscription...': 'Aboneliğiniz etkinleştiriliyor...',
    'Cancel Plan': 'Planı iptal et',
    'Cancel plugin': 'Uygulamayı iptal et',
    'Confirm Cancellation': 'İptali onayla',
    'Enterprise Contact': 'Kurumsal İletişim',
    'or contact us at': 'veya bize ulaşın',
    'Most Popular': 'En Popüler',
    'Upgrade Now': 'Şimdi Yükselt',
    'Free Forever': 'Ömür Boyu Ücretsiz',
    'per month': 'aylık',
    'Contact us for pricing': 'Fiyatlandırma için bize ulaşın',
    '/mo': '/ay',
    Disconnect: 'Bağlantıyı Kes',
    'Upgrade Your Account': 'Hesabınızı Yükseltin',
    'Choose the perfect plan for your business needs and unlock more features':
      'İşletmeniz için en uygun planı seçin ve daha fazla özellik kullanın',
    'Current Plan': 'Mevcut Plan',
    'Plan activated': 'Plan etkinleştirildi',
    'Select a shop first': 'Önce bir mağaza seçin',
    'Cancel your paid plan to return to Free':
      'Ücretsiz plana dönmek için ücretli planınızı iptal edin',
    'Contact Sales': 'Satış Ekibiyle İletişime Geç',
    'Need help choosing the right plan?':
      'Doğru planı seçmekte yardıma mı ihtiyacınız var?',
    'Contact Support': 'Destek ile İletişime Geç',
    Custom: 'Özel',
    'Perfect for getting started': 'Başlamak için ideal',
    'For small businesses': 'Küçük işletmeler için',
    'For growing businesses': 'Büyüyen işletmeler için',
    'For large organizations': 'Büyük organizasyonlar için',
    '1 Shop': '1 Mağaza',
    'Free Menu Management': 'Ücretsiz Menü Yönetimi',
    'QR Code Generation': 'QR Kod Oluşturma',
    'Email Support': 'E-posta Desteği',
    'Free Analytics': 'Ücretsiz Analitik',
    'Up to 2 Shops': 'En fazla 2 Mağaza',
    'Unlimited menu items': 'Sınırsız menü öğesi',
    'Custom QR Codes': 'Özel QR Kodları',
    'Priority Support': 'Öncelikli Destek',
    'Advanced Analytics': 'Gelişmiş Analitik',
    'Paid marketplace apps': 'Ücretli pazar yeri uygulamaları',
    'Unlimited Shops': 'Sınırsız Mağaza',
    'Custom Branding': 'Özel Markalama',
    'All Pro Features': 'Tüm Pro Özellikleri',
    'Dedicated Account Manager': 'Özel Hesap Yöneticisi',
    '24/7 Phone Support': '7/24 Telefon Desteği',
    'Custom Integrations': 'Özel Entegrasyonlar',
    'White Label Solution': 'White Label Çözüm',
    'Advanced Security': 'Gelişmiş Güvenlik',
    'SLA Guarantee': 'SLA Garantisi',
  },
  de: {},
  fr: {},
  it: {},
}
